// extracted by mini-css-extract-plugin
export default {"content":"Fund_content__ZsTlX"};